import React, { useEffect, useState } from "react";
import ReactGA from "react-ga";
import { Window, WindowContent, WindowHeader, Button, Toolbar, reset, themes } from "react95";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import Navigation from "./components/Navigation/navigation";
import ScraperWindow from "./components/ScraperWindow";
import ErrorWindow from "./components/ErrorWindow";
import useSelectedScraper from "./hooks/useSelectedScraper";
import "./App.css";

const ResetStyles = createGlobalStyle`
  ${reset}
`;

const Container = styled.div`
    display: flex;
    justify-content: center;
`;

const WindowWrapper = styled.div`
    width: 100%;
    position: relative;
    z-index: 0;
`;

const App = () => {
    const selectedScraper = useSelectedScraper();
    const [gaInitialised, setGaInitialised] = useState(false);

    useEffect(() => {
        if (!gaInitialised) {
            ReactGA.initialize(process.env.REACT_APP_GA_ID);
            setGaInitialised(true);
        }
    }, [gaInitialised]);

    return (
        <Container>
            <ResetStyles />
            <ThemeProvider theme={themes.default}>
                <ErrorWindow />
                <WindowWrapper>
                    <Window>
                        <WindowHeader
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                            }}
                        >
                            <span>beet_harvester.exe</span>

                            <Button
                                style={{ marginRight: "-6px", marginTop: "1px" }}
                                size="sm"
                                square
                            >
                                <span style={{ fontWeight: "bold", transform: "translateY(-1px)" }}>
                                    x
                                </span>
                            </Button>
                        </WindowHeader>
                        <Toolbar>
                            <Button variant="menu" size="sm">
                                File
                            </Button>
                            <Button variant="menu" size="sm">
                                Edit
                            </Button>
                            <Button variant="menu" size="sm" disabled>
                                Save
                            </Button>
                        </Toolbar>
                        <WindowContent>
                            <Navigation />
                            <ScraperWindow scraperName={selectedScraper} />
                        </WindowContent>
                    </Window>
                </WindowWrapper>
            </ThemeProvider>
        </Container>
    );
};

export default App;
